<script lang="ts">
  import type { AlternateLinksProps } from './alternate-links.types';
  import { page } from '$app/state';

  const { links }: AlternateLinksProps = $props();
</script>

<svelte:head>
  {#if links}
    {#each Object.entries(links) as [lang, url] (lang)}
      <link rel="alternate" hreflang={lang} href={`${page.url.origin}${url}`} />
    {/each}
  {/if}
</svelte:head>
